import chevyExpress12 from "@/assets/slot-photos/chevy-express-12.jpg";
import chevyExpress15 from "@/assets/slot-photos/chevy-express-15.jpg";
import fordTransit12 from "@/assets/slot-photos/ford-transit-12.jpg";
import fordTransit15 from "@/assets/slot-photos/ford-transit-15.jpg";
import fordTransitHigh15 from "@/assets/slot-photos/ford-transit-high-15.jpg";
import fordTransitLow12 from "@/assets/slot-photos/ford-transit-low-12.jpg";
import fordTransitLow15 from "@/assets/slot-photos/ford-transit-low-15.jpg";
import mercedesSprinter12 from "@/assets/slot-photos/mercedes-sprinter-12.jpg";
import mercedesSprinter12Tv from "@/assets/slot-photos/mercedes-sprinter-12-tv.jpg";
import mercedesSprinter15 from "@/assets/slot-photos/mercedes-sprinter-15.jpg";
import mercedesSprinter15Tv from "@/assets/slot-photos/mercedes-sprinter-15-tv.jpg";
import mercedesSprinterOlder12 from "@/assets/slot-photos/mercedes-sprinter-older-12.jpg";
import mercedesSprinterOlder15 from "@/assets/slot-photos/mercedes-sprinter-older-15.jpg";

export const SLOT_PHOTOS: Record<string, string> = {
  "chevy-express:12": chevyExpress12,
  "chevy-express:15": chevyExpress15,
  "ford-transit:12": fordTransit12,
  "ford-transit:15": fordTransit15,
  "ford-transit-high:15": fordTransitHigh15,
  "ford-transit-low:12": fordTransitLow12,
  "ford-transit-low:15": fordTransitLow15,
  "mercedes-sprinter:12": mercedesSprinter12,
  "mercedes-sprinter:12:tv": mercedesSprinter12Tv,
  "mercedes-sprinter:15": mercedesSprinter15,
  "mercedes-sprinter:15:tv": mercedesSprinter15Tv,
  "mercedes-sprinter-older:12": mercedesSprinterOlder12,
  "mercedes-sprinter-older:15": mercedesSprinterOlder15,
};
